<div class="mobile-dropdown-wrapper">
    <select [(ngModel)]="activeNode" (ngModelChange)="selectNode($event)">
        <option [ngValue]="activeNode">{{ activeNode.title }}</option>
        <option *ngFor="let node of secondLevelNodes" [ngValue]="node">
            {{ node.title }}
        </option>
    </select>
    <i class="down-arrow fas fa-angle-down"></i>
</div>
